import { cache } from 'react';
import {
  ISettings,
  ISourceSettings,
  ITgBotSettings,
  IWebSettings,
} from '../_types';
import { request } from './http-client';

async function getSiteSettings(id: string, platform_id?: string) {
  try {
    const response = await request.get<IWebSettings>(
      `/v1/website-settings/shipper_id/${id}`,
      {
        headers: {
          Shipper: id,
          Platform: platform_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}
export async function getSiteSettingsWithDomain(
  domain: string,
  platform_id?: string
) {
  return request.get<IWebSettings>(`/v1/website-settings/domain/${domain}`, {
    headers: {
      Platform: platform_id,
    },
  });
}

export const fetchSiteSettingsWithDomain = cache(
  async (domain: string, platform_id?: string) => {
    const response = await fetch(
      process.env.NEXT_PUBLIC_BASE_URL +
        `/v1/website-settings/domain/${domain}`,
      {
        headers: {
          Platform: platform_id || '',
        },
      }
    );

    return response.json();
  }
);

// Remove cache() from these - they might not be tenant-safe
export async function getSourceSettings(id?: string, shipperId?: string) {
  return request.get<ISourceSettings>(`/v3/source-settings/${id}`, {
    headers: shipperId ? { Shipper: shipperId } : undefined,
  });
}

export async function getTgBotSettings(id?: string) {
  return request.get<ITgBotSettings>(`/v1/tgbot_settings/${id}`);
}

export async function getSettings(params: {
  page: number;
  limit: number;
  object_id: string;
  object_type: string;
  fields: 'product_cooking_time';
}) {
  return request.get<ISettings>(`/v2/settings`, { params });
}

export default getSiteSettings;
